<div mat-dialog-content>

    <div *ngFor="let currentFile of filesProgress; index as i;">
        <div>{{ currentFile.fileName}}</div>
        <p class="progress">
            <mat-progress-bar mode="determinate" value="{{currentFile.progress}}"></mat-progress-bar>
        </p>
        <div  *ngIf="currentFile.error" class="error">
            {{currentFile.error}}
        </div>
        <div *ngIf="currentFile.progress == 100 && !currentFile.error" class="success">
            {{ 'COMMON.FILE-UPLOADED-SUCCESSFULLY' | translate }}
        </div>
    </div>
</div>
  
  
<div mat-dialog-actions align="center">    
    <button mat-raised-button color="primary" class="w-100" cdkFocusInitial (click)="onClose($event)" [disabled]="!btnEnabled">{{'COMMON.OK' | translate}}</button>
</div> 
